/**
 * Apply locale to the document root.
 * Sets `dir` (rtl/ltr) and `lang` on <html> so CSS logical properties
 * cascade RTL layout to all modules without per-component changes.
 */
export function applyLocale(locale: "en" | "ar"): void {
  const isRtl = locale === "ar";
  document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", locale);
}
